import { ApiAction } from 'redux-upgrader'

export const GET_TOS_INFO = new ApiAction('GET_TOS_INFO')
export const SET_TOS_INFO = new ApiAction('SET_TOS_INFO')
